module.exports = function (array) {
  return array.filter(function (item) { return item; });
};
